const USERS_ACTIVE_OPTIONS = [
  {
    label: 'Active users',
    value: 't',
  },
  {
    label: 'Inactive users',
    value: 'f',
  },
];

const SALES_SUSPENSION_OPTIONS = [
  {
    label: 'Both',
    value: null,
  },
  {
    label: 'Sales suspended',
    value: 't',
  },
  {
    label: 'Sales not suspended',
    value: 'f',
  },
];

const CORPORATE_OPTIONS = [
  {
    label: 'Corporate flag = Yes',
    value: 't',
  },
];

const INCORPORATED_CITY_OPTIONS = [
  {
    label: 'Is in incorporated city area',
    value: 't',
  },
  {
    label: 'Is outside incorporated city area',
    value: 'f',
  },
];

const BUSINESS_OPTIONS = [
  {
    label: 'In business',
    value: 't',
  },
  {
    label: 'Not in business',
    value: 'f',
  },
];

// Demographics

const INCOME_OPTIONS = [
  {
    label: 'Very Low Income',
    value: '1',
  },
  {
    label: 'Low Income',
    value: '2',
  },
  {
    label: 'Medium Income',
    value: '3',
  },
  {
    label: 'High Income',
    value: '4',
  },
  {
    label: 'Very High Income',
    value: '5',
  },
];

const UNDER_AGE_18_OPTIONS = [
  {
    label: 'Very Low Youth',
    value: '1',
  },
  {
    label: 'Low Youth',
    value: '2',
  },
  {
    label: 'Medium Youth',
    value: '3',
  },
  {
    label: 'High Youth',
    value: '4',
  },
  {
    label: 'Very High Youth',
    value: '5',
  },
];

const URBAN_RURAL_OPTIONS = [
  {
    label: 'Entirely Rural',
    value: '1',
  },
  {
    label: 'Mostly Rural',
    value: '2',
  },
  {
    label: 'Mixed Urban and Rural',
    value: '3',
  },
  {
    label: 'Mostly Urban',
    value: '4',
  },
  {
    label: 'Entirely Urban',
    value: '5',
  },
];

const ETHNICITY_HISPANIC_OPTIONS = [
  {
    label: 'Very Low Hispanic Population',
    value: '1',
  },
  {
    label: 'Low Hispanic Population',
    value: '2',
  },
  {
    label: 'Medium Hispanic Population',
    value: '3',
  },
  {
    label: 'High Hispanic Population',
    value: '4',
  },
  {
    label: 'Very High Hispanic Population',
    value: '5',
  },
];

const AFRICAN_BLACK_OPTIONS = [
  {
    label: 'Very Low Black Population',
    value: '1',
  },
  {
    label: 'Low Black Population',
    value: '2',
  },
  {
    label: 'Medium Black Population',
    value: '3',
  },
  {
    label: 'High Black Population',
    value: '4',
  },
  {
    label: 'Very High Black Population',
    value: '5',
  },
];

const NATIVE_AMERICAN_OPTIONS = [
  {
    label: 'Very Low Native American Population',
    value: '1',
  },
  {
    label: 'Low Native American Population',
    value: '2',
  },
  {
    label: 'Medium Native American Population',
    value: '3',
  },
  {
    label: 'High Native American Population',
    value: '4',
  },
  {
    label: 'Very High Native American Population',
    value: '5',
  },
];

const ASIAN_PACIFIC_OPTIONS = [
  {
    label: 'Very Low Asian/Pacific Population',
    value: '1',
  },
  {
    label: 'Low Asian/Pacific Population',
    value: '2',
  },
  {
    label: 'Medium Asian/Pacific Population',
    value: '3',
  },
  {
    label: 'High Asian/Pacific Population',
    value: '4',
  },
  {
    label: 'Very High Asian/Pacific Population',
    value: '5',
  },
];

const RACE_WHITE_OPTIONS = [
  {
    label: 'Very Low White Population',
    value: '1',
  },
  {
    label: 'Low White Population',
    value: '2',
  },
  {
    label: 'Medium White Population',
    value: '3',
  },
  {
    label: 'High White Population',
    value: '4',
  },
  {
    label: 'Very High White Population',
    value: '5',
  },
];

const RACE_OTHER_OPTIONS = [
  {
    label: 'Very Low Other Race Population',
    value: '1',
  },
  {
    label: 'Low Other Race Population',
    value: '2',
  },
  {
    label: 'Medium Other Race Population',
    value: '3',
  },
  {
    label: 'High Other Race Population',
    value: '4',
  },
  {
    label: 'Very High Other Race Population',
    value: '5',
  },
];

const COLLEGE_GRADUATE_OPTIONS = [
  {
    label: 'Very Low College Degree Education',
    value: '1',
  },
  {
    label: 'Low College Degree Education',
    value: '2',
  },
  {
    label: 'Medium College Degree Education',
    value: '3',
  },
  {
    label: 'High College Degree Education',
    value: '4',
  },
  {
    label: 'Very High College Degree Education',
    value: '5',
  },
];

const SOME_COLLEGE_OPTIONS = [
  {
    label: 'Very Low Some College Education',
    value: '1',
  },
  {
    label: 'Low Some College Education',
    value: '2',
  },
  {
    label: 'Medium Some College Education',
    value: '3',
  },
  {
    label: 'High Some College Education',
    value: '4',
  },
  {
    label: 'Very High Some College Education',
    value: '5',
  },
];

const HIGH_SCHOOL_OPTIONS = [
  {
    label: 'Very Low High School Education Only',
    value: '1',
  },
  {
    label: 'Low High School Education Only',
    value: '2',
  },
  {
    label: 'Medium High School Education Only',
    value: '3',
  },
  {
    label: 'High High School Education Only',
    value: '4',
  },
  {
    label: 'Very High High School Education Only',
    value: '5',
  },
];

const NO_HIGH_SCHOOL_OPTIONS = [
  {
    label: 'Very Low No High School Diploma',
    value: '1',
  },
  {
    label: 'Low No High School Diploma',
    value: '2',
  },
  {
    label: 'Medium No High School Diploma',
    value: '3',
  },
  {
    label: 'High No High School Diploma',
    value: '4',
  },
  {
    label: 'Very High No High School Diploma',
    value: '5',
  },
];

const EDUCATION_ACHIEVEMENT = [
  {
    label: 'Very Low Educational Achievement',
    value: '1',
  },
  {
    label: 'Low Educational Achievement',
    value: '2',
  },
  {
    label: 'Medium Educational Achievement',
    value: '3',
  },
  {
    label: 'High Educational Achievement',
    value: '4',
  },
  {
    label: 'Very High Educational Achievement',
    value: '5',
  },
];

const POPULATION_DENSITY = [
  {
    label: 'Very Low Population Density',
    value: '1',
  },
  {
    label: 'Low Population Density',
    value: '2',
  },
  {
    label: 'Medium Population Density',
    value: '3',
  },
  {
    label: 'High Population Density',
    value: '4',
  },
  {
    label: 'Very High Population Density',
    value: '5',
  },
];

const STORE_TYPE_OPTIONS = [
  {
    label: 'Convenience store with or without gas',
    value: '1',
  },
  {
    label: 'Drug store or pharmacy',
    value: '2',
  },
  {
    label: 'Beer, wine, liquor store',
    value: '3',
  },
  {
    label: 'Grocery store',
    value: '4',
  },
  {
    label: 'Mass merchandiser',
    value: '5',
  },
  {
    label: 'Tobacco shop',
    value: '6',
  },
  {
    label: 'Hookah lounge',
    value: '7',
  },
  {
    label: 'E-cigarette/Vape shop',
    value: '8',
  },
  {
    label: 'Bar or Restaurant',
    value: '9',
  },
  {
    label: 'Smoking bar',
    value: '10',
  },
  {
    label: 'Other store, not listed',
    value: '99',
  },
];

const NEAR_SCHOOL_OPTIONS = [
  {
    label: 'Within 1,000’ of a school',
    value: 't',
  },
  {
    label: 'Not within 1,000’ of a school',
    value: 'f',
  },
];

const VIOLATION_FOUND_OPTIONS = [
  {
    label: 'Yes',
    value: 't',
  },
  {
    label: 'No',
    value: 'f',
  },
];

const VIOLATION_CASES_OPTIONS = [
  {
    label: 'Open',
    value: 't',
  },
  {
    label: 'Closed',
    value: 'f',
  },
];

const VIOLATION_NUMBER_OPTIONS = [
  {
    label: '1-3',
    value: '1t3',
  },
  {
    label: '4-6',
    value: '4t6',
  },
  {
    label: '7-9',
    value: '7t9',
  },
  {
    label: '>10',
    value: 'gte10',
  },
];

const NEAR_RETAILER_OPTIONS = [
  {
    label: 'Within 500’ of another retailer',
    value: 't',
  },
  {
    label: 'Not within 500’ of another retailer',
    value: 'f',
  },
];

const HAS_PHARMACY_OPTIONS = [
  {
    label: 'Has a pharmacy counter',
    value: 't',
  },
  {
    label: 'Does not have a pharmacy counter',
    value: 'f',
  },
];

const YES_NO_OPTIONS = [
  {
    label: 'Both',
    value: null,
  },
  {
    label: 'Yes',
    value: 't',
  },
  {
    label: 'No',
    value: 'f',
  },
];

const RETAILER_LOCATION_ACCURACY_OPTIONS = [
  {
    label: 'Has high-accuracy geocode',
    value: 't',
  },
  {
    label: 'Does not have high-accuracy geocode',
    value: 'f',
  },
];

const RETAILER_ADDRESS_VALIDATED_OPTIONS = [
  {
    label: 'Has validated address',
    value: 't',
  },
  {
    label: 'Does not have a validated address',
    value: 'f',
  },
];

const OBJECT_TYPE_OPTIONS = [
  {
    label: 'Retailer',
    value: 'retailer',
  },
  {
    label: 'License',
    value: 'license',
  },
  {
    label: 'Enforcement',
    value: 'visit',
  },
  {
    label: 'User',
    value: 'user',
  },
  {
    label: 'Agency',
    value: 'agency',
  },
  {
    label: 'Store merger',
    value: 'storemerger',
  },
  {
    label: 'Unsuccessful login',
    value: 'unsuccessfullogin',
  },
  {
    label: 'Successful login',
    value: 'successfullogin',
  },
  {
    label: 'Log access',
    value: 'logaccess',
  },
  {
    label: 'Suspension',
    value: 'salessuspension',
  },
];

const ACTION_TYPE_OPTIONS = [
  {
    label: 'Deleted',
    value: 'deleted',
  },
  {
    label: 'Edited',
    value: 'edited',
  },
  {
    label: 'Created',
    value: 'created',
  },
  {
    label: 'Restored',
    value: 'restored',
  },
  {
    label: 'Log access',
    value: 'logaccess',
  },
  {
    label: 'Log in',
    value: 'login',
  },
  {
    label: 'Historic',
    value: 'historic',
  },
  {
    label: 'Separate',
    value: 'separate',
  },
  {
    label: 'Duplicate',
    value: 'duplicate',
  },
];

const INSPECTION_TYPE_OPTIONS = [
  {
    label: 'Undercover Buy',
    value: '1',
  },
  {
    label: 'Advertising limitations',
    value: '3',
  },
  {
    label: 'Failure to display license',
    value: '4',
  },
  {
    label: 'Failure to verify age',
    value: '5',
  },
  {
    label: 'Flavored tobacco',
    value: '6',
  },
  {
    label: 'Hookah',
    value: '7',
  },
  {
    label: 'Internet/Mail violation',
    value: '8',
  },
  {
    label: 'Non-MSA inventory',
    value: '9',
  },
  {
    label: 'Open Packages/Singles',
    value: '10',
  },
  {
    label: 'Package size',
    value: '11',
  },
  {
    label: 'Sale to a minor',
    value: '12',
  },
  {
    label: 'Self-Service',
    value: '13',
  },
  {
    label: 'Shoulder Tap',
    value: '14',
  },
  {
    label: 'Signage Check',
    value: '2',
  },
  {
    label: 'Unlicensed',
    value: '15',
  },
  {
    label: 'Untaxed product',
    value: '16',
  },
  {
    label: 'Other',
    value: '17',
  },
];

const VIOLATION_OPTIONS = [
  {
    label: 'Violation was found',
    value: '3',
  },
  {
    label: 'Violation was not found',
    value: '1',
  },
  {
    label: 'Violation status not determined',
    value: '2',
  },
];
const SALE_TO_MINOR_OPTIONS = [
  {
    label: 'Sale was made to a minor',
    value: 't',
  },
  {
    label: 'Sale WAS NOT made to a minor',
    value: 'f',
  },
  {
    label: 'Sale minor status unknown',
    value: 'none',
  },
];

const YOUTH_INVOLVED_OPTIONS = [
  {
    label: 'Youth was involved',
    value: 't',
  },
  {
    label: 'Youth WAS NOT involved',
    value: 'f',
  },
  {
    label: 'Youth involvement unknown',
    value: 'none',
  },
];

const PENALTY_OPTIONS = [
  {
    label: 'Warning',
    value: '1',
  },
  {
    label: 'Fine',
    value: '2',
  },
  {
    label: 'Suspension/NTSO',
    value: '4',
  },
  {
    label: 'Revocation',
    value: '3',
  },
  {
    label: 'Other',
    value: '5',
  },
];

const PRODUCTS_OPTIONS = [
  {
    label: 'Cigarettes in a package',
    value: '1',
  },
  {
    label: 'Cigars',
    value: '2',
  },
  {
    label: 'Electronic Device',
    value: '3',
  },
  {
    label: 'ENDS/E-liquid',
    value: '4',
  },
  {
    label: 'Hookah tobacco',
    value: '5',
  },
  {
    label: 'Leaf Tobacco, Cigarettes',
    value: '6',
  },
  {
    label: 'Little Cigars & Cigarillos',
    value: '7',
  },
  {
    label: 'Papers/Cigarette',
    value: '8',
  },
  {
    label: 'Paraphernalia',
    value: '9',
  },
  {
    label: 'Pipe Tobacco',
    value: '10',
  },
  {
    label: 'RYO - Cigarette tobacco',
    value: '11',
  },
  {
    label: 'Single cigarette',
    value: '12',
  },
  {
    label: 'Smokeless tobacco/Chew',
    value: '13',
  },
  {
    label: 'Snus & Dissolvables',
    value: '14',
  },
  {
    label: 'Flavors',
    value: '17',
  },
  {
    label: 'Other',
    value: '15',
  },
];

const ENFORCEMENT_STATUS = [
  {
    label: 'Violation',
    value: '3',
  },
  {
    label: 'No Violation',
    value: '1',
  },
  {
    label: 'Pending',
    value: '2',
  },
];
const LICENCE_STATUS_OPTIONS = [
  {
    label: 'Valid',
    value: 'VALID',
  },
  {
    label: 'Revoked',
    value: 'REVOKED',
  },
  {
    label: 'Suspended',
    value: 'SUSPENDED',
  },
  {
    label: 'Ended',
    value: 'ENDED',
  },
  {
    label: 'Ends Soon (next 30 days)',
    value: 'END_SOON',
  },
];

const LICENCE_SUSPENDED_OPTIONS = [
  {
    label: 'License suspended',
    value: 't',
  },
  {
    label: 'License not suspended',
    value: 'f',
  },
];

const VIOLATION_TYPE_OPTIONS = [
  {
    label: 'None',
    value: '1',
  },
  {
    label: 'Loose cigarettes sold',
    value: '2',
  },
  {
    label: 'Flavored products or flavor enhancers (including mint/menthol flavors) sold',
    value: '3',
  },
  {
    label: 'Missing or incomplete manufacturer document certifying products are not flavored',
    value: '4',
  },
  {
    label: 'Vape product with nicotine content over 35 mg/ml',
    value: '5',
  },
  {
    label: 'Missing or incomplete manufacturer document displaying nicotine content of available vape products',
    value: '6',
  },
  {
    label: 'Missing local BOH and DOR permit',
    value: '7',
  },
  {
    label: 'Missing signage',
    value: '8',
  },
  {
    label: 'Advertising for products not sold in store',
    value: '9',
  },
  {
    label: 'Tobacco products sold on or in front of the counter',
    value: '10',
  },
  {
    label: 'Noncompliance with local cigar packaging/pricing regulation',
    value: '11',
  },
  {
    label: 'Other (please specify)',
    value: '12',
  },
];

const VIOLATION_ACTION_TYPE_OPTIONS = [
  {
    label: 'Educational warning',
    value: '1',
  },
  {
    label: '$1,000 fine',
    value: '2',
  },
  {
    label: '$2,000 fine',
    value: '3',
  },
  {
    label: '$5,000 fine',
    value: '4',
  },
  {
    label: 'Other fine',
    value: '5',
  },
  {
    label: 'Citation issued (or will be issued) to clerk',
    value: '6',
  },
  {
    label: 'Citation issued (or will be issued) to establishment',
    value: '7',
  },
  {
    label: 'Referral given to another agency',
    value: '8',
  },
  {
    label: 'Citation issued (or will be issued) to establishment: No fine',
    value: '9',
  },
  {
    label: 'Citation issued (or will be issued) to establishment: $1,000 fine',
    value: '10',
  },
  {
    label: 'Citation issued (or will be issued) to establishment: $2,000 fine',
    value: '11',
  },
  {
    label: 'Citation issued (or will be issued) to establishment: $5,000 fine',
    value: '12',
  },
  {
    label: 'Citation issued (or will be issued) to establishment: Custom fine',
    value: '13',
  },
  {
    label: 'Citation issued (or will be issued) to clerk: No fine',
    value: '14',
  },
  {
    label: 'Citation issued (or will be issued) to clerk: $1,000 fine',
    value: '15',
  },
  {
    label: 'Citation issued (or will be issued) to clerk: $2,000 fine',
    value: '16',
  },
  {
    label: 'Citation issued (or will be issued) to clerk: $5,000 fine',
    value: '17',
  },
  {
    label: 'Citation issued (or will be issued) to clerk: Custom fine',
    value: '18',
  },
];

const SELLS_TOBACCO_OPTIONS = [
  {
    label: 'Sells tobacco',
    value: 't',
  },
  {
    label: 'Does not sell tobacco',
    value: 'f',
  },
  {
    label: 'Sells tobacco is unknown',
    value: 'null',
  },
];

const SELLS_ALCOHOL_OPTIONS = [
  {
    label: 'Sells alcohol',
    value: 't',
  },
  {
    label: 'Does not sell alcohol',
    value: 'f',
  },
];

const HAS_HAD_VISITS = [
  {
    label: 'Has had visit types:',
    value: 'any,ever',
  },
];
const RETAILER_VISIT_TYPE = [
  {
    id: 0,
    label: 'any',
    value: 'any',
  },
  {
    id: 1,
    label: 'assessment',
    value: 'assessment',
  },
  {
    id: 2,
    label: 'enforcement',
    value: 'enforcement',
  },
  {
    id: 3,
    label: 'education',
    value: 'education',
  },
];

const RETAILER_VISIT_DATE_RANGE = [
  {
    label: 'ever',
    value: 'ever',
  },
  {
    label: 'date',
    value: 'date',
  },
];

export default {
  USERS_ACTIVE_OPTIONS,
  SALES_SUSPENSION_OPTIONS,
  CORPORATE_OPTIONS,
  BUSINESS_OPTIONS,
  INCORPORATED_CITY_OPTIONS,
  INCOME_OPTIONS,
  UNDER_AGE_18_OPTIONS,
  URBAN_RURAL_OPTIONS,
  ETHNICITY_HISPANIC_OPTIONS,
  AFRICAN_BLACK_OPTIONS,
  NATIVE_AMERICAN_OPTIONS,
  ASIAN_PACIFIC_OPTIONS,
  RACE_WHITE_OPTIONS,
  RACE_OTHER_OPTIONS,
  COLLEGE_GRADUATE_OPTIONS,
  SOME_COLLEGE_OPTIONS,
  HIGH_SCHOOL_OPTIONS,
  NO_HIGH_SCHOOL_OPTIONS,
  NEAR_SCHOOL_OPTIONS,
  NEAR_RETAILER_OPTIONS,
  HAS_PHARMACY_OPTIONS,
  YES_NO_OPTIONS,
  RETAILER_LOCATION_ACCURACY_OPTIONS,
  RETAILER_ADDRESS_VALIDATED_OPTIONS,
  OBJECT_TYPE_OPTIONS,
  ACTION_TYPE_OPTIONS,
  INSPECTION_TYPE_OPTIONS,
  VIOLATION_OPTIONS,
  SALE_TO_MINOR_OPTIONS,
  YOUTH_INVOLVED_OPTIONS,
  PENALTY_OPTIONS,
  PRODUCTS_OPTIONS,
  ENFORCEMENT_STATUS,
  LICENCE_STATUS_OPTIONS,
  LICENCE_SUSPENDED_OPTIONS,
  EDUCATION_ACHIEVEMENT,
  POPULATION_DENSITY,
  VIOLATION_FOUND_OPTIONS,
  VIOLATION_CASES_OPTIONS,
  VIOLATION_NUMBER_OPTIONS,
  VIOLATION_TYPE_OPTIONS,
  VIOLATION_ACTION_TYPE_OPTIONS,
  STORE_TYPE_OPTIONS,
  SELLS_TOBACCO_OPTIONS,
  SELLS_ALCOHOL_OPTIONS,
  HAS_HAD_VISITS,
  RETAILER_VISIT_TYPE,
  RETAILER_VISIT_DATE_RANGE,
};
